import { render } from "./TokenAttachmentList.vue?vue&type=template&id=5ccab97c"
import script from "./TokenAttachmentList.vue?vue&type=script&lang=ts"
export * from "./TokenAttachmentList.vue?vue&type=script&lang=ts"
script.render = render

export default script